module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0750.a19f7fb3.jpg";